"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgGenderUnidentified = function SvgGenderUnidentified(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 11 20"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#179FE3",
    d: "m3.512 12.47-2.33-5.286a1 1 0 0 1 1.05-1.394l1.929.265a1 1 0 0 0 .136.009H6.67a1 1 0 0 0 .134-.01l2.37-.32a.42.42 0 0 1 .47.359"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#E568B2",
    d: "m7.796 8.207 2.01 3.88a1 1 0 0 1-.888 1.46H8.14a1 1 0 0 0-1 1v2.77a1 1 0 0 1-1 1H4.972a1 1 0 0 1-1-1v-2.802a1 1 0 0 0-1-1h-.504"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.614,
    cy: 2.159,
    r: 2.159,
    stroke: "#179FE3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C2C5CC",
    d: "m.437 14.839 9.9-9.9.706.708-9.899 9.899z"
  })));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgGenderUnidentified);
var _default = exports["default"] = Memo;